import { getMeteringService } from '@landsbankinn/analytics-manager';
import { useResource } from '@landsbankinn/l16n';
import { UIKitContextProvider } from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import { THEME_GRID_IDP, zIndexConfig } from 'src/containers/config.ts';
import { useUIKitFontScale } from './useUIKitFontScale';

export function UIKitProvider(props: { children: ReactNode }) {
  useUIKitFontScale();

  const { r } = useResource();

  return (
    <UIKitContextProvider
      zIndexConfig={zIndexConfig}
      r={r}
      themeGrid={THEME_GRID_IDP}
      meteringService={getMeteringService()}
    >
      {props.children}
    </UIKitContextProvider>
  );
}
